import { Injectable } from '@angular/core';
import { Router, Params, ActivatedRoute, Resolve } from '@angular/router';
import { Provider } from './provider.model';
import { ProviderService } from './provider.service';


@Injectable()
export class ProviderListGuard implements Resolve<Provider> {

  constructor(public router: Router, private providerService: ProviderService) { }

  resolve() {
    return this.providerService.getProviderList(null);
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/provider/provider-list.guard.ts